import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import DashboardPage from "../pages/dashboard/DashboardPage";
import ManageUsersPage from "../pages/users/ManageUsersPage";
import UserDetailsPage from "../pages/users/UserDetailsPage";
import CreateNewUserPage from "../pages/users/CreateNewUserPage";
import UserCourseEnrollmentPage from "../pages/users/UserCourseEnrollmentPage";
import ManageCoursesPage from "../pages/courses/ManageCoursesPage";
import CourseDetailsPage from "../pages/courses/CourseDetailsPage";
import CreateNewCoursePage from "../pages/courses/CreateNewCoursePage";
import CourseReorderPage from "../pages/courses/CourseReorderPage";
import ManageParamsPage from "../pages/params/ManageParamsPage";
import SignInPage from "../pages/SignInPage";
import NotFoundPage from "../pages/NotFoundPage";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import userService from '../services/usersService';
import SurveyReportPage from "../pages/surveyReport/SurveyReportPage";
import UsersStatusPage from "../pages/users/UsersStatusPage";
import FeatureReportsPage from "../pages/reports/ReportsPage";
import UserReportsPage from "../pages/userReports/UserReportsPage";
import RolloutFeaturePage from "../pages/rolloutFeature/RolloutFeaturePage";
import CopyDataPage from "../pages/copyData/CopyDataPage";
import OnboardingSettingsPage from "../pages/onboarding/OnboardingSettingsPage";
import CreateEditSection from "../pages/onboarding/components/CreateEditSection";
import OnboardingInsightsPage from "../pages/onboarding/OnboardingInsightsPage";

function AdminRoutes() {
  const isAuthenticated = userService.isAuthenticated();
  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path="/sign-in" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <SignInPage />} />
      </Route>
      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/users" element={<ManageUsersPage />} />
        <Route path="/users/status" element={<UsersStatusPage />} />
        <Route path="/users/edit/:userId" element={<UserDetailsPage />} />
        <Route path="/users/create" element={<CreateNewUserPage />} />
        <Route path="/users/:userId/course-enrollment" element={<UserCourseEnrollmentPage />} />
        <Route path="/courses" element={<ManageCoursesPage />} />
        <Route path="/courses/edit/:courseId" element={<CourseDetailsPage />} />
        <Route path="/courses/create" element={<CreateNewCoursePage />} />
        <Route path="/courses/order" element={<CourseReorderPage />} />
        <Route path="/params" element={<ManageParamsPage />} />
        <Route path="/survey_report" element={<SurveyReportPage />} />
        <Route path="/feature_reports" element={<FeatureReportsPage />} />
        <Route path="/rollout_feature" element={<RolloutFeaturePage />} />
        <Route path="/user_reports/:userId" element={<UserReportsPage />} />
        <Route path="/copy_data" element={<CopyDataPage />} />
        <Route path="/onboarding" element={<OnboardingSettingsPage />} />
        <Route path="/create_section" element={<CreateEditSection />} />
        <Route path="/update_section" element={<CreateEditSection />} />
        <Route path="/onboarding/insights" element={<OnboardingInsightsPage />} />
      </Route>
      <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/sign-in"} replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default AdminRoutes;
